"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThumbDownIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const ThumbDownIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "0 0 28 28" }),
    react_1.default.createElement("path", { d: "M30.47,14.46a2.53,2.53,0,0,0-1.31-1.81,2.57,2.57,0,0,0-.84-4.28A2.56,2.56,0,0,0,26.6,4.11a2.59,2.59,0,0,0,.49-2A2.6,2.6,0,0,0,24.5,0H16.69A9.21,9.21,0,0,0,13.1.73L10,2.76a1,1,0,0,0-.46.84v9.1h0a1,1,0,0,0,.37.69,56,56,0,0,1,3.58,4.47,15,15,0,0,1,.89,1.49,3.65,3.65,0,0,1,.33,1.13,33,33,0,0,1,.28,3.61,0.5,0.5,0,0,0,.17.37,2,2,0,0,0,1,.5l0.28,0c1.62,0,2.75-2.17,2.88-2.43a5.6,5.6,0,0,0,.5-1.56,7.31,7.31,0,0,0-.24-3.73L28,17.44a2.51,2.51,0,0,0,1.91-.88A2.59,2.59,0,0,0,30.47,14.46Z" }),
    react_1.default.createElement("rect", { y: "0.5", width: "8", height: "16", rx: "1.5", ry: "1.5" })));
exports.ThumbDownIcon = ThumbDownIcon;
exports.default = exports.ThumbDownIcon;
